module.exports = __webpack_public_path__ + "img/Mount2.3ea70c93.jpg";